import React, { useState, useEffect } from "react";
import "./ServicesSlider.css";
import img from "../../Images/event.png";

export default function ServicesSlider() {
  const [index, setIndex] = useState(0);
  const [visibleCards, setVisibleCards] = useState(4);

  const services = [
    { title: "Wedding" },
    { title: "Reception" },
    { title: "Corporate Party" },
    { title: "Birthday Party" },
    { title: "Anniversary" },
    { title: "Private Event" },
  ];

  // Detect screen size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 600) {
        setVisibleCards(1);
      } else if (window.innerWidth <= 992) {
        setVisibleCards(2);
      } else {
        setVisibleCards(4);
      }
      setIndex(0); // reset position on resize
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const maxIndex = services.length - visibleCards;

  const nextSlide = () => {
    if (index < maxIndex) {
      setIndex(prev => prev + 1);
    }
  };

  const prevSlide = () => {
    if (index > 0) {
      setIndex(prev => prev - 1);
    }
  };

  return (
    <section className="services-section">
      <div className="container">

        <div className="section-header">
          <span className="line"></span>
          <p>Our Services</p>
          <span className="line"></span>
        </div>

        <h2 className="main-title">
          Explore Our <span>Services</span>
        </h2>

        <div className="slider-wrapper">

          <button className="nav-btn left" onClick={prevSlide}>
            ❮
          </button>

          <div className="slider-container">
            <div
              className="slider-track"
              style={{
                transform: `translateX(-${index * (100 / visibleCards)}%)`,
              }}
            >
              {services.map((item, i) => (
                <div
                  className="card"
                  key={i}
                  style={{ minWidth: `${100 / visibleCards}%` }}
                >
                  <img src={img} alt={item.title} />
                  <div className="card-body">
                    <h3>{item.title}</h3>
                    <p>
                      Nestled in the heart of the city,
                      Luxe Venue offers a sophisticated
                      blend of elegance and comfort.
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button className="nav-btn right" onClick={nextSlide}>
            ❯
          </button>

        </div>
      </div>
    </section>
  );
}